import styled, { css } from 'styled-components';
import { device } from '../../../../styles/devices';
import { COLORS, SIZING } from '../../../../styles/variables';

interface StyleProps {
  visible?: boolean;
}

export const StyledInput = styled.input<{ error?: boolean }>`
  width: 100%;
  border: none;
  height: 36px;
  font-size: 16px;
  background-color: transparent;
  font-family: Audi Type;
  border-bottom: 1px solid ${(props) => (props.error ? COLORS.error : COLORS.grey60)};
  padding-left: ${SIZING.unit(4.5)};
  padding-right: ${SIZING.unit(3)};
  :focus-visible {
    outline: none;
  }
  &::placeholder {
    // ASK
    font-family:
      Audi Type,
      sans-serif;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.002px;
    font-size: 16px;
    @media ${device.tablet} {
      color: ${COLORS.grey80};
      line-height: 24px;
      letter-spacing: 0.003px;
    }
    @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
      color: ${COLORS.white};
    }
  }
`;

export const SearchIconContainer = styled.div`
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
`;

export const ClearInputWrapper = styled.div`
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  top: 0;
  right: 0;
  visibility: hidden;
  cursor: pointer;
  ${({ visible }: StyleProps) => {
    if (visible)
      return css`
        visibility: visible;
      `;
    return '';
  }};
`;

export const ErrorWrapper = styled.div`
  margin-top: ${SIZING.unit(1.5)};
  display: none;
  align-items: center;
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  gap: 8px;
  color: ${COLORS.error};
  svg {
    min-width: fit-content;
  }
  ${({ visible }: StyleProps) => {
    if (visible)
      return css`
        display: flex;
      `;
    return '';
  }};
`;

export const InputFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const PlaceHolderForLandscape = styled.div`
  margin-top: ${SIZING.unit(1.5)};
  font-family: Audi Type;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey80};
  display: none;
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    display: block;
  }
`;

export const SuggestionsContainer = styled.ul`
  position: absolute;
  top: 36px;
  margin: 0;
  border-radius: 8px;
  padding: ${SIZING.unit(0.625)} 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-radius: 8px;
  border: 0.5px solid ${COLORS.menuBorder};
  background: ${COLORS.menuBackground};
  width: 100%;
  box-shadow:
    0px 2px 12px 0px rgba(0, 0, 0, 0.15),
    0px 0px 6px 0px rgba(0, 0, 0, 0.05) inset;
  z-index: 5;
`;

export const Option = styled.li<{ focused?: boolean }>`
  width: 100%;
  background-color: ${(props) => (props.focused ? COLORS.grey70 : '')};
  display: flex;
  align-items: flex-start;
  padding: ${SIZING.unit(0.125)} ${SIZING.unit(0.5)};
  border-radius: 8px;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  font-family: 'Audi Type', sans-serif;
  cursor: pointer;
  color: ${(props) => (props.focused ? COLORS.white : COLORS.menuTextColor)};
`;

export const CheckMarkWrapper = styled.span<{ focused?: boolean }>`
  visibility: ${(props) => (props.focused ? '' : 'hidden')};
  width: 18px;
  height: 18px;
  padding-top: ${SIZING.unit(0.5)};
`;

export const BoldText = styled.span`
  font-weight: bold;
`;

export const Container = styled.div``;
